import React, { useRef } from "react";

import Button from "./Button";
import Modal from "./Modal";

type Props = {
  open: boolean;
  title: React.ReactNode;
  description?: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
  onCancel: () => void;
  onConfirm: () => void | Promise<void>;
};

/**
 * Thin wrapper over the Modal primitive for destructive or irreversible
 * confirmations. Focuses the Cancel button by default so users don't
 * accidentally confirm by pressing Enter.
 */
const ConfirmDialog: React.FC<Props> = ({
  open,
  title,
  description,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  destructive = false,
  onCancel,
  onConfirm,
}) => {
  const cancelRef = useRef<HTMLButtonElement>(null);

  return (
    <Modal
      open={open}
      onClose={onCancel}
      size="sm"
      initialFocusRef={cancelRef}
      title={title}
      description={description}
      footer={
        <>
          <Button ref={cancelRef} variant="secondary" onClick={onCancel}>
            {cancelLabel}
          </Button>
          <Button
            variant={destructive ? "destructive" : "primary"}
            onClick={() => onConfirm()}
          >
            {confirmLabel}
          </Button>
        </>
      }
    />
  );
};

export default ConfirmDialog;
